import { Box, SkeletonText, Text } from "@chakra-ui/react";
import { Modal } from "antd";
import PrimaryButton from "components/Button/PrimaryButton";
import useHistoricoCobrancaObservacao from "core/features/cobranca/hooks/useHistoricoCobrancaObservacao";

interface ModalAnotacoesHistoricoCobrancaProps {
  isOpen: boolean;
  onClose: () => any;
  historicoId?: string;
}

function ModalAnotacoesHistoricoCobranca({
  isOpen,
  onClose,
  historicoId,
}: ModalAnotacoesHistoricoCobrancaProps) {
  const { data, isLoading, isFetching } =
    useHistoricoCobrancaObservacao(historicoId);

  const _isLoading = isLoading || isFetching;

  return (
    <Modal
      visible={isOpen}
      title="Anotações"
      footer={
        <Box
          display="flex"
          gridGap={6}
          justifyContent="flex-end"
          flex={1}
          mt={8}
        >
          <PrimaryButton onClick={onClose}>Fechar</PrimaryButton>
        </Box>
      }
      onCancel={onClose}
      width="781px"
    >
      {_isLoading ? (
        <SkeletonText mt={-8} />
      ) : (
        <Text mt={-8}>{data?.observacao}</Text>
      )}
    </Modal>
  );
}

export default ModalAnotacoesHistoricoCobranca;
